import { Capacitor } from "@capacitor/core";

/**
 * Where an analytics event was produced. Our Capacitor app loads the
 * production site in a WebView without a custom user agent, so its sessions
 * are otherwise indistinguishable from any other iOS/Android WebView.
 */
export type AnalyticsPlatform = "web" | "ios_app" | "android_app";

/** Pure detection helper — safe to call during SSR (always 'web' there). */
export function getAnalyticsPlatform(): AnalyticsPlatform {
  if (typeof window === "undefined") return "web";
  try {
    if (!Capacitor.isNativePlatform()) return "web";
    const platform = Capacitor.getPlatform();
    if (platform === "ios") return "ios_app";
    if (platform === "android") return "android_app";
    return "web";
  } catch {
    return "web";
  }
}
